<script lang="ts">
	// Design system components
	import { Select } from '@Shelly/shelly-design-system';
	// Config
	import { getTRVSchemeChartConfig } from 'src/helpers/statistics/config/temp_scheme';
	import { getDailyRangeOptions, startsWeekOnSun } from 'src/helpers/date_helper';
	// Components
	import LayerChartRenderer from '../LayerChart/LayerChartRenderer.svelte';
	//Types
	import type { ChartDataInterface } from 'src/types/Chart';
	import type { IChartTempSchedule } from 'src/types/TemperatureSchemeType';
	import { format } from 'svelte-i18n';

	export let data: IChartTempSchedule;

	const startWeekOnSun = startsWeekOnSun(),
		rangeOptions = getDailyRangeOptions(startWeekOnSun),
		onChangeRange = (range: number) => {
			rangeValue = rangeOptions.find((el) => el.value === range);
			chartData = getTRVSchemeChartConfig(range, data, startWeekOnSun);
		},
		selectChangeRange = (e: CustomEvent | { detail: number }) => {
			onChangeRange(e.detail.value);
		};

	let rangeValue = rangeOptions[0],
		chartData: ChartDataInterface;

	$: chartData = getTRVSchemeChartConfig(rangeValue.value, data, startWeekOnSun);
</script>

<div class="d-flex">
	<Select
		id="select-schedules-chart-range"
		aria-label={$format('select_schedules_chart_range', {
			default: 'Select schedules chart range',
		})}
		value={rangeValue}
		size="m"
		icon="fas fa-clock-rotate-left"
		options={rangeOptions}
		on:change={selectChangeRange}
	/>
</div>
<LayerChartRenderer {chartData} />
